<template>
  <div class="card card-user">
    <div class="image">
      <img src="static/img/background.jpg" alt="...">
    </div>
    <div class="card-content" v-if="profile">
      <div class="author">
        <img class="avatar border-white" :src="profile.photoURL ? profile.photoURL : 'static/img/default-avatar.png'" alt="...">
        <h4 class="title">{{ profile.displayName }}
          <br>
          <a href="#" v-if="company">
            <small>{{ company.name }}</small>
          </a>
        </h4>
      </div>
      <p class="description text-center">
        {{profile.bio}}
      </p>
    </div>
    <hr>
    <div class="text-center" v-if="profile">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <h5>{{profile.email}}
            <br>
            <small>Email</small>
          </h5>
        </div>
        <div class="col-md-10 col-md-offset-1">
          <h5>{{profile.phoneNumber}}
            <br>
            <small>Téléphone</small>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('profiles', {
        profile: 'mine'
      }),
      ...mapGetters('companies', {
        company: 'mine'
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/User/UserProfile/UserCard.vue